import packageJson from '../../package.json';
const env = import.meta.env.VITE_NODE_ENV || 'development';
const enableReduxDevMiddleware =
  import.meta.env.VITE_REDUX_DEV_MIDDLEWARE === 'true' && env !== 'production' && env !== 'test';

// DataDog version
const datadogVersion = import.meta.env.VITE_SHA ?? packageJson.version;

export const settings = { env, enableReduxDevMiddleware, datadogVersion };
